module.exports = __webpack_public_path__ + "img/ico-notice.bdf0d3b7.png";